import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
export default class {
  constructor() {
    this.init();
    this.smallOnly();
    this.swiperColumn();
    this.slideMv();
  }

  init() {
    const swiperImterview = new Swiper('.js-index-interview', {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 1,
      scrollbar: {
        el: '.js-interview-scrollbar',
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1008: {
          slidesPerView: 3.5,
          spaceBetween: 60,
          loop: true,
          navigation: {
            nextEl: '.js-interview-button-next',
            prevEl: '.js-interview-button-prev',
          },
          pagination: {
            el: '.js-interview-pagination',
            type: 'fraction',
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          },
        },
      },
    });
    const swiperBlog = new Swiper('.js-index-blog', {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 1,
      scrollbar: {
        el: '.js-blog-scrollbar',
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1008: {
          slidesPerView: 3.5,
          spaceBetween: 60,
          loop: true,
          navigation: {
            nextEl: '.js-blog-button-next',
            prevEl: '.js-blog-button-prev',
          },
          pagination: {
            el: '.js-blog-pagination',
            type: 'fraction',
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          },
        },
      },
    });
    const swiperBlogSingle = new Swiper('.js-blog-single', {
      speed: 400,
      spaceBetween: 20,
      slidesPerView: 1.03,
      loop: true,
      scrollbar: {
        el: '.js-blog-single-scrollbar',
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: 40,
          loop: true,
        },
      },
    });
    const otherBlog = new Swiper('.js-c-other-blog', {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 1,
      scrollbar: {
        el: '.js-c-other-blog-scrollbar',
        draggable: true, // スクロールバーをドラッグ可能にする
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1008: {
          slidesPerView: 4,
          spaceBetween: 60,
          loop: true,
          scrollbar: {
            el: '.js-c-other-blog-scrollbar',
            draggable: true, // スクロールバーをドラッグ可能にする
          },
          navigation: {
            nextEl: '.js-c-other-blog-button-next',
            prevEl: '.js-c-other-blog-button-prev',
          },
          pagination: {
            el: '.js-c-other-blog-pagination',
            type: 'fraction',
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          },
        },
      },
    });
    const otherStory = new Swiper('.js-other-story', {
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 1,
      scrollbar: {
        el: '.js-other-story-scrollbar',
        draggable: true, // スクロールバーをドラッグ可能にする
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1008: {
          slidesPerView: 4,
          spaceBetween: 60,
          loop: true,
          scrollbar: {
            el: '.js-other-story-scrollbar',
            draggable: true, // スクロールバーをドラッグ可能にする
          },
          navigation: {
            nextEl: '.js-other-story-button-next',
            prevEl: '.js-other-story-button-prev',
          },
          pagination: {
            el: '.js-other-story-pagination',
            type: 'fraction',
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          },
        },
      },
    });
  }
  smallOnly() {
    const otherInterview = document.querySelector('.js-other-interview');
    const breakPoint = '1008';
    let interviewSlide;
    let flag;
    if (otherInterview) {
      window.addEventListener(
        'load',
        () => {
          if (breakPoint < window.innerWidth) {
            flag = true;
          } else {
            flag = false;
          }
        },
        false
      );
      window.addEventListener(
        'resize',
        () => {
          if (breakPoint < window.innerWidth && flag) {
            interviewSlide.destroy(false, true);
            flag = false;
          } else if (breakPoint >= window.innerWidth && !flag) {
            interviewSlide();
            flag = true;
          }
        },
        false
      );
      const interviewSlide = () => {
        swiper = new Swiper(otherInterview, {
          speed: 400,
          spaceBetween: 25,
          slidesPerView: 1,
          //loop: true,
          //autoplay: {
          //	delay: 4000,
          //	disableOnInteraction: false,
          //},
          scrollbar: {
            el: '.js-other-interview-scrollbar',
            draggable: true, // スクロールバーをドラッグ可能にする
          },
          breakpoints: {
            1008: {
              slidesPerView: 4,
              spaceBetween: 60,
            },
          },
        });
      };
    }
  }
  swiperColumn() {
    //スライダーの個数を取得
    const columnSlider = document.querySelector('.swiper.js-index-column');

		if (columnSlider) {
      const num = columnSlider.dataset.number;
      let loop = false;
      if (num > 3) {
        loop = true;
      }

      const swiperColumn = new Swiper('.js-index-column', {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        scrollbar: {
          el: '.js-blog-scrollbar',
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        breakpoints: {
          1008: {
            slidesPerView: 3.5,
            spaceBetween: 60,
            loop,
            navigation: {
              nextEl: '.js-blog-button-next',
              prevEl: '.js-blog-button-prev',
            },
            pagination: {
              el: '.js-blog-pagination',
              type: 'fraction',
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
              },
            },
          },
        },
      });
    }
  }
  slideMv() {
    //スライダーの個数を取得
    const countMv = document.querySelector('.js-mv-slide');

    if (countMv) {
      const num = countMv.dataset.number;
      const slideMv = new Swiper('.p-recruitenews__slide.js-mv-slide', {
        direction: 'vertical',
        slidesPerView: 1,
        speed: 300,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.js-recruitnews-button-next',
          prevEl: '.js-recruitnews-button-prev',
        },
        breakpoints: {
          // 1080: {
          //   slidesPerView: 2,
          // },
          1280: {
            slidesPerView: 3,
          },
        },
      });
    }
  }
}
